import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-circle"} maskId="square-filled-radius-0-stroke-1-IconFormCircle"><circle cx="12" cy="12" r="10" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormCircle;
